export const projectsData = [
    {
        id: 'asparagusbird',
        title: 'Asparagus Bird Repeller',
        shortDescription: 'Üretken yapay zeka destekli, kuşlara zarar vermeden çalışan yeni nesil kuş uzaklaştırma sistemi.',
        category: 'Yapay Zeka & Sürdürülebilir Teknoloji',
        image: '/images/asparagus-bird.jpg',
        liveUrl: 'https://asparagusbr.com/',
        technologies: ['Üretken Yapay Zeka', 'Ses Analizi', 'Görüntü İşleme', 'IoT', 'Python'],
        overview: {
            title: 'Proje Hakkında',
            description: 'Asparagus Bird Repeller, tarım alanları, sanayi sahaları ve açık alanlarda kuş kaynaklı sorunlara canlı dostu ve sürdürülebilir bir yaklaşım sunmak amacıyla geliştirilmiştir. Batman Üniversitesi akademisyenleri ve BRİSA iş birliğiyle geliştirilen bu yenilikçi çözüm; doğal ses ve görüntü uyarılarıyla kuşların güvenli şekilde ortamdan uzaklaşmasını sağlar. Sistem, üretken yapay zeka teknolojisi sayesinde kuş davranışlarını analiz eder; rastgele değil, ortama ve duruma uygun ses ve görsel uyarılar üretir. Böylece kuşlar strese girmeden, zarar görmeden alandan uzaklaşır.'
        },
        challenges: {
            title: 'Neden Asparagus Bird Repeller?',
            items: [
                'Kuşlara fiziksel zarar vermez, tamamen etik ve canlı haklarına saygılı',
                'Doğal davranışları hedef alarak etkili koruma sağlar',
                'Çevreye ve ekosisteme duyarlıdır',
                'Klasik sabit ses sistemlerinden daha etkilidir',
                'Akıllı, adaptif ve sürdürülebilir bir çözümdür'
            ]
        },
        solutions: {
            title: 'Kullanılan Teknoloji',
            items: [
                'Üretken yapay zeka algoritmaları ile kuş türleri ve hareket örüntülerinin analizi',
                'Çevresel koşullara göre adaptif ses ve görüntü uyarıları üretimi',
                'Doğal algılara uygun uyarı sistemleri sayesinde kuşların sisteme alışmasının önlenmesi',
                'Hiçbir fiziksel, kimyasal veya zararlı yöntem kullanılmadan etkili uzaklaştırma',
                'Akademik bilgi birikimi ile endüstriyel tecrübenin birleşimi'
            ]
        },
        features: {
            title: 'Özellikler ve Kullanım Alanları',
            items: [
                'Canlı Dostu Yaklaşım: Elektrik şoku, fiziksel engel, zararlı kimyasal veya aşırı yüksek ses kullanmaz',
                'Tarım alanları için özel koruma (özellikle açık tarım sahaları)',
                'Sanayi tesisleri ve depolama alanlarında etkin koruma',
                'Açık kampüs, tesis alanları ve çatı çevrelerinde kullanım',
                'Batman Üniversitesi ve BRİSA iş birliğiyle akademik ve endüstriyel destek',
                'Sürdürülebilir ve geleceğin çevre ihtiyaçlarına yönelik teknoloji'
            ]
        }
    },
    {
        id: 'smartfibtest',
        title: 'SmartFibTest',
        shortDescription: 'Hızlı ve doğru karaciğer test analiz platformu.',
        category: 'Sağlık Teknolojisi',
        image: '/images/fib-1.JPG',
        liveUrl: 'https://smartfibtest.com/',
        technologies: ['React', 'Python', '.NET', 'MSSQL'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'SmartFibTest, karaciğer sağlığı testlerini analiz etmek ve hızlı bir şekilde sonuç sağlamak için geliştirilen yenilikçi bir dijital platformdur. Bu platform, doktorların ve hastaların test sonuçlarına kolaylıkla ulaşmasını sağlarken, yapay zeka tabanlı analizlerle ileri düzey yorumlama ve skorlamalar sunar.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Yüksek hassasiyet gerektiren yapay zeka modelleri',
                'Büyük test verilerinin hızlı bir şekilde işlenmesi',
                'Hastaların ve doktorların farklı ihtiyaçlarına uygun kullanıcı arayüzü'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'Yapay zeka tabanlı veri analitiği ve TensorFlow kullanımı',
                'Optimize edilmiş veri işleme algoritmaları',
                'Doktor ve hasta için özelleştirilebilir kullanıcı panelleri'
            ]
        },
        features: {
            title: 'Özellikler',
            items: [
                'Yapay zeka destekli test analizi',
                'Fibroz ve Acti Skor hesaplama',
                'Doktor yorumlama paneli',
                'Detaylı hasta raporlama'
            ]
        }
    },
    {
        id: 'yorumune',
        title: 'Yorumu Ne?',
        shortDescription: 'Farklı pazaryerlerindeki ürün yorumlarını analiz eden akıllı platform.',
        category: 'Veri Analizi & Aggregasyon',
        image: '/images/yorumune-1.png',
        liveUrl: 'https://yorumune.com/',
        technologies: ['React', 'Node.js', 'MongoDB', 'Express'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'Yorumu Ne?, farklı e-ticaret pazaryerlerindeki ürünlere yapılan kullanıcı yorumlarını toplayarak, bu yorumları kategorize eden ve analiz eden akıllı bir platformdur. Platform, "Duygu Dağılımı" ve "Yıldız Dağılımı" grafikleriyle yorumları görselleştirerek son kullanıcıya ürün hakkında bilinçli karar vermesini sağlayacak kapsamlı bir bakış açısı sunar.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Farklı pazaryerlerinden veri toplama ve entegrasyon',
                'Büyük veri setlerinin analizi ve kategorize edilmesi',
                'Yorumların duygu analizinin yapılması ve görselleştirilmesi'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'Yapay zeka tabanlı duygu analizi ve kategorileme algoritmaları',
                'Gerçek zamanlı veri toplama ve senkronizasyon sistemi',
                'İnteraktif grafikler ve veri görselleştirme araçları'
            ]
        },
        features: {
            title: 'Özellikler',
            items: [
                'Farklı pazaryerlerinden yorum toplama ve aggregasyon',
                'Duygu Dağılımı grafiği ile yorumların pozitif/negatif analizi',
                'Yıldız Dağılımı ile detaylı değerlendirme istatistikleri',
                'Kategorize edilmiş yorumlar ile kolay filtreleme',
                'Kullanıcıya bilinçli karar verme desteği'
            ]
        }
    },
    {
        id: 'ipcp',
        title: 'iPCP - Akıllı Pompa Kontrol Platform',
        shortDescription: 'Yapay zeka destekli kuyu yönetimi ve pompa kontrol sistemi.',
        category: 'Endüstriyel IoT & Yapay Zeka',
        image: '/images/ipcp-1.jpg',
        liveUrl: '#',
        technologies: ['IoT', 'Yapay Zeka', 'Python', 'React', 'Sensör Teknolojileri'],
        overview: {
            title: 'Proje Genel Bakış',
            description: 'iPCP, kuyularınızda iPCP teknolojilerini kullandığınızda, tüm sahanızı tek bir noktadan takip edebilecek, kuyularınızda oluşan problemleri anında görerek hızlı müdale etme imkanı kazanacaksınız. Yapay Zeka kabileyeti sayesinde her bir kuyunuz özel öğrenen model ile, akıllı pompa hız kontrolü ve frenlemeye sahip olacak. Sistem, veri kaydı, yazılım ve raporlama ile yapay zeka modüllerini bir araya getirerek endüstriyel süreçlerde tam kontrol sağlar.'
        },
        challenges: {
            title: 'Karşılaşılan Zorluklar',
            items: [
                'Kuyu üzerindeki sensörlerden kablosuz ve kesintisiz veri toplanması',
                'Gerçek zamanlı pompa hız kontrolü ve fren sistemi entegrasyonu',
                'Her kuyu için özel öğrenen yapay zeka modellerinin geliştirilmesi',
                'Büyük ölçekli saha yönetimi ve merkezi takip sistemi'
            ]
        },
        solutions: {
            title: 'Geliştirilen Çözümler',
            items: [
                'IoT sensör ağı ile kablosuz ve güvenilir veri toplama altyapısı',
                'Yapay zeka tabanlı öğrenen modeller ile kuyu bazlı optimizasyon',
                'Gerçek zamanlı pompa kontrol algoritmaları ve akıllı frenleme',
                'Merkezi izleme paneli ile tüm sahanın tek noktadan yönetimi',
                'Detaylı raporlama ve yazılım modülleri'
            ]
        },
        features: {
            title: 'Özellikler',
            items: [
                'Veri Kaydı: Kuyu sensörlerinden kesintisiz veri toplama',
                'Yazılım ve Raporlama: Güncel teknolojilerle geliştirilmiş yazılım ve detaylı raporlama',
                'Yapay Zeka: Kuyu bazlı makine öğrenmesi ile akıllı pompa kontrolü',
                'Akıllı pompa hız kontrolü ve fren sistemi',
                'Tek noktadan saha yönetimi ve hızlı müdahale imkanı',
                'iPCP teknolojisi ile endüstriyel otomasyon'
            ]
        }
    }
];
